import { MinisiteConfiguration, ToolsConfiguration } from '@3ddv/ngx-sites-builder-lib';
import { Injectable } from '@angular/core';
import { dbSiteConfiguration } from '../models/minisite.model';

@Injectable({
  providedIn: 'root',
})
export class SaveMinisiteService {
  constructor() { }

  public siteDataToForm(dbData: dbSiteConfiguration, minisiteConfiguration: MinisiteConfiguration): FormData {
    // Data to transform into json file to upload
    const formData: FormData = new FormData();

    // Tools with images to append: logo, favicon, multivenue
    const toolsConfig = minisiteConfiguration.toolsConfig;
    //1. Append logo
    if (toolsConfig.logo.file) {
      let ext_split = toolsConfig.logo.file.name.split('.');
      let ext = ext_split[ext_split.length - 1];
      formData.append('logo_file', toolsConfig.logo.file, 'logo.' + ext);
      toolsConfig.logo.file = null;
    }
    //1.2 Append favicom
    if (toolsConfig.favicon.file) {
      let ext_split = toolsConfig.favicon.file.name.split('.');
      let ext = ext_split[ext_split.length - 1];
      formData.append('favicon_file', toolsConfig.favicon.file, 'favicon.' + ext);
      toolsConfig.favicon.file = null;
    }
    //2. Append multivenue possible icons
    if (toolsConfig.multivenue && toolsConfig.multivenue.enabled && toolsConfig.multivenue.venues.length) {
      toolsConfig.multivenue.venues = toolsConfig.multivenue.venues.map(v => {
        if (v.file) {
          let ext_split = v.file.name.split('.');
          let ext = ext_split[ext_split.length - 1];
          const newname = v.id + '.' + ext;
          formData.append('multivenue_files', v.file, newname);
          // Remove Preview
          v.logoPreview = null;
          v.file = null;
        }
        return v;
      });
    }

    // this.minisiteConfiguration.mapConfig.client = this.client;
    // this.minisiteConfiguration.mapConfig.enabled = Boolean(this.enableSiteOnPublish);
    // this.minisiteConfiguration.toolsConfig = Object.assign({}, toolsConfig);

    // Transform json to string
    const body = JSON.stringify(minisiteConfiguration);
    const blob = new Blob([body], { type: 'application/json' });
    // Transform string to file
    const file = new File([blob], 'master.json');
    // Add to form
    formData.append('master_file', file);

    // BD required data
    formData.append('client_key', dbData.client_key);
    formData.append('venue_key', dbData.venue_key);
    // Comprobar si existe el valor para que no de error al guardar el site en DB
    if (dbData.template_color_id) formData.append('template_color_id', dbData.template_color_id);
    if (dbData.template_map_id) formData.append('template_map_id', dbData.template_map_id);
    formData.append('workflow_id', dbData.workflow_id);
    formData.append('title', dbData.title);
    formData.append('url', dbData.url);
    formData.append('venue_code', dbData.venue_code);
    formData.append('map_id', dbData.map_id);
    formData.append('is_active', String(dbData.is_active)); // Envía los boleanos en forma de string, ya que el formData no acepta boolean
    formData.append('editor2dmapsdemo', String(dbData.editor2dmapsdemo));
    formData.append('isTest', String(dbData.isTest));
    formData.append('libversion', String(dbData.libVersion));
    //! Provisional hasta que se haga el fix en el back para leer los boolean y no en number
    // formData.append('is_active', dbData.is_active ? '1' : '0'); // Envía '0' | '1'
    // formData.append('editor2dmapsdemo', dbData.editor2dmapsdemo ? '1' : '0');
    // formData.append('isTest', dbData.isTest ? '1' : '0');

    /* 
    console.log('master_file', this.minisiteConfiguration);
    console.log('logo_file');
    console.log('favicon_file');
    console.log('multivenue_files');
    console.log('client_key', this.selectedClient[0].key);
    console.log('venue_key', this.venue.key);
    console.log('workflow_id', this.minisiteConfiguration.mapConfig.workflow_id.toString());
    console.log('title', this.minisiteConfiguration.mapConfig.client);
    console.log('url', environment.sitesBuilder.app_url + this.minisiteConfiguration.mapConfig.client);
    console.log('venue_code', this.minisiteConfiguration.mapConfig.venue_id);
    console.log('map_id', this.minisiteConfiguration.mapConfig.map_id);
    console.log('is_active', this.enableSiteOnPublish.toString());
    // console.log('minisite_id', this.minisiteDB.id);
    */

    return formData;
  }
}
